import { DRNUtil } from '@traveloka/district-util';
import React, { forwardRef, useState, useImperativeHandle } from 'react';
import { Animated } from 'react-native';
import BMNotificationBanner from '../NotificationBanner/BMNotificationBanner';
import { createPortal } from '../Portal/createPortal';
import { getNotificationBannerStyle } from './utils';
export const NotificationBannerContainer = forwardRef((props, forwardedRef) => {
    const [state, setState] = useState({
        type: 'PUSH_NOTIFICATION',
        modalVisible: false,
        position: 'TOP_RIGHT',
        title: '',
        message: '',
    });
    const [translateX, setTranslateX] = useState(0);
    const onLayout = (event) => {
        const { width } = event.nativeEvent.layout;
        setTranslateX(-width / 2);
    };
    function showNotification(config) {
        setState({
            ...state,
            ...config,
            modalVisible: true,
            position: config.position ? config.position : 'TOP_RIGHT',
        });
    }
    function closeNotification() {
        setState({
            ...state,
            modalVisible: false,
        });
    }
    useImperativeHandle(forwardedRef, () => ({
        show: (config) => {
            showNotification(config);
        },
        close: () => {
            closeNotification();
        },
    }));
    if (state.modalVisible) {
        return createPortal(<Animated.View onLayout={onLayout} style={getNotificationBannerStyle(state, translateX)}>
        <BMNotificationBanner {...props} {...state}/>
      </Animated.View>, DRNUtil.isWeb() ? document.body : null);
    }
    return null;
});
const errorMessage = 'BMNotificationBannerManager instance is not available, did you forget to render BMNotificationBannerProvider?';
const BMNotificationBannerManager = Object.assign(NotificationBannerContainer, {
    instance: null,
    show: (config) => {
        var _a, _b;
        if (!(BMNotificationBannerManager === null || BMNotificationBannerManager === void 0 ? void 0 : BMNotificationBannerManager.instance)) {
            throw new Error(errorMessage);
        }
        (_b = (_a = BMNotificationBannerManager.instance).show) === null || _b === void 0 ? void 0 : _b.call(_a, config);
    },
    close: () => {
        var _a, _b;
        if (!(BMNotificationBannerManager === null || BMNotificationBannerManager === void 0 ? void 0 : BMNotificationBannerManager.instance)) {
            throw new Error(errorMessage);
        }
        (_b = (_a = BMNotificationBannerManager.instance).close) === null || _b === void 0 ? void 0 : _b.call(_a);
    },
});
export default BMNotificationBannerManager;
